/**
 * Archivo utilizado para configurar la estrategía predeterminada
 * para la política de reintentos dentro de las peticiones http
 */

import { Observable, timer, of } from 'rxjs'
import { HttpErrorResponse } from '@angular/common/http'
import { delayWhen, mergeMap } from 'rxjs/operators'
import { environment } from '@environments/environment'
import { RetryModel } from '@models/common/retry.model'

export const genericRetryStrategy =({
    maxRetryAttempts = environment.MAX_RETRY_ERRORS,
    duration = environment.ERROR_DELAY,
    excludedStatusCodes = environment.EXCLUDED_STATUS_CODE,
    flagConsole = environment.DEBUG_LOG,
    nameRequest = "",
    consoleAux = ""
}: RetryModel = {}) => {
    return (errors$: Observable<HttpErrorResponse>) => {
        return errors$.pipe(
            delayWhen(() => timer(Number(duration))),
            mergeMap((error: HttpErrorResponse, i) => {
                const retryAttempt = i + 1;
                if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find(e => e === error.status)) {
                    throw error;
                }
                return of(null)
            }),
        )
    }    
}